import userAPI from '../../api/userAPI';

export default {
	namespaced: true,
	state: {
		hospital: {}, // 医院信息
	},
	getters: {
		// 获取医院信息
		hospital(state) {
			return state.hospital;
		},
	},
	mutations: {
		// 设置医院信息
		setHospital(state, hospital) {
			state.hospital = hospital;
		},
		// 清空医院信息
		clearHospital(state) {
			state.hospital = {};
		}
	},
	actions: {
		/** 获取职称信息
     * @param {Object} params-请求参数
     */
		async getPosition() {
			try {
				const position = await userAPI.getPosition();
				return position;
			} catch (error) {
				// 抛出异常
				throw error;
			}
		},
		/** 获取科室信息
     * @param {Object} params-请求参数
     */
		async getDepartment() {
			try {
				const department = await userAPI.getDepartment();
				return department;
			} catch (error) {
				// 抛出异常
				throw error;
			}
		},
		/** 获取所属局
     * @param {Object} params-请求参数
     */
		async getBureau() {
			try {
				const bureau = await userAPI.getBureau();
				return bureau;
			} catch (error) {
				// 抛出异常
				throw error;
			}
		},
		// 获取医院信息
		/**
     * @param {Object} params-请求
     * @param {Number} params.id-查询ID id:0-省 1-市 2-区、县 4-医院
     * @param {String} params.name-关键字模糊查询医院名称
     */
		async getHospitalList(context, params) {
			try {
				// 获取医院信息
				const hospital = await userAPI.getHospitalList(params);
				return hospital;
			} catch (error) {
				// 抛出异常
				throw error;
			}
		},
		// 获取城市信息
		/**
     * @param {Object} params-请求
     * @param {String} params.companyCode-公司编码
     * @param {Number} params.areaCode-专区编码
     */
		async getCitys(context, params) {
			try {
				// 获取医院信息
				const data = await userAPI.getCitys(params);
				return data;
			} catch (error) {
				// 抛出异常
				throw error;
			}
		},
	}
};



// WEBPACK FOOTER //
// ./src/store/modules/setting.js